import { gql } from '@apollo/client';

import { insuranceFragment, hotelFragment } from 'store/fragments';
import PAYMENTS_FEE from './PAYMENTS_FEE';
import PAYMENTS_LEG from './PAYMENTS_LEG';
import PAYMENTS_PAYMENT from './PAYMENTS_PAYMENT';
import PAYMENTS_PRODUCT from './PAYMENTS_PRODUCT';

export default gql`
  query booking($reference: String!, $currency: Currency!) {
    booking(reference: $reference) {
      reference
      currency
      isLoyalty
      salesChannelCode
      displayStatus @client
      createTimestamp
      confirmedTimestamp
      changeExpiryTimestamp
      cancelledTimestamp
      vouchers {
        id
        code
      }
      customer {
        firstName
        lastName
        companyName
        email
        phoneNumber
        unformattedPhoneNumber {
          countryCode
          number
        }
        address {
          street
          city
          postalCode
          countryCode
        }
      }
      additionalDetails {
        value
        key
        itemRef
      }
      notes {
        createdAt
      }
      passengers {
        id
        lastName
        email
        travelDocumentsRequired {
          travelDocumentType
          required
        }
      }
      nonExchangedOutbound: outbound(hideExchanged: true) {
        id
      }
      nonExchangedInbound: inbound(hideExchanged: true) {
        id
      }
      payments {
        ...PaymentsPayment
        action @client
        display @client
      }
      offlineFees: fees {
        ...PaymentsFee
      }
      hotelCancellationFees {
        ...PaymentsFee
      }
      insuranceCancellationFees {
        ...PaymentsFee
      }
      hotelMarginCancellationFees {
        ...PaymentsFee
      }
      trainMarginCancellationFees {
        ...PaymentsFee
      }
      hotelExchangeFees {
        ...PaymentsFee
      }
      bidUpgradeFees {
        ...PaymentsFee
      }
      travelPassProductsCancellationFees(tariffCode: TH_TP_CAN_FEE) {
        ...PaymentsFee
      }
      outbound {
        ...PaymentsLeg
      }
      inbound {
        ...PaymentsLeg
      }
      insurances {
        ...CompleteInsurance
      }
      outboundExtras {
        ...PaymentsProduct
      }
      flowForwardFees(cancelled: false) {
        ...PaymentsFee
      }
      impulseUpgradeFees(cancelled: false) {
        ...PaymentsFee
      }
      agent {
        organization
        office
        username
      }
      latestRevisionSource {
        username
      }
      productFamily
      productFamilyGroup
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      totalPriceToBePaidInBookingCurrency: totalPriceToBePaidWithCurrency
      expiryTimestamp
      status
      onHoldInBookingCurrency: onHoldWithCurrency {
        depositAmount
        expiryTimestamp
      }
      hotels {
        ...CompleteHotel
      }
      externalBookingReferences {
        source
        externalId
      }
      wasPurchasedWithSubscription
      onHold {
        depositAmount
      }
      allBookingItems @client {
        passengerId
      }
    }
  }

  ${PAYMENTS_FEE}
  ${PAYMENTS_LEG}
  ${PAYMENTS_PAYMENT}
  ${PAYMENTS_PRODUCT}
  ${hotelFragment}
  ${insuranceFragment}
`;
